"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    "FRIDAY": "Пятница",
    "MONDAY": "понедельник",
    "SATURDAY": "Суббота",
    "SUNDAY": "Воскресенье",
    "THURSDAY": "четверг",
    "TUESDAY": "вторник",
    "WEDNESDAY": "среда",
    "and": "а также",
    "day_few": "дни",
    "day_many": "дни",
    "day_one": "день",
    "day_other": "дни",
    "day_plural": "дни",
    "freeOfCharge": "Бесплатно",
    "hour_one": "час",
    "hour_one_plural": "часы",
    "hour_other": "часы",
    "minute_few": "минута",
    "minute_many": "минута",
    "minute_one": "минута",
    "minute_other": "минуты",
    "ocpiRestrictionsAfterDuration": "Через {{minDuration}}",
    "ocpiRestrictionsBetweenDuration": "Между {{minDuration}} и {{maxDuration}}",
    "ocpiRestrictionsFirstDuration": "Первый {{maxDuration}}",
    "ocpiRestrictionsKwhAbove": "Когда потребление энергии превышает {{minKwh}}",
    "ocpiRestrictionsKwhBetween": "При потреблении энергии между {{minKwh}} и {{maxKwh}}",
    "ocpiRestrictionsKwhLessThan": "При потреблении энергии менее {{maxKwh}}",
    "session": "сеанс",
    "theDay_few": "день",
    "theDay_many": "день",
    "theDay_one": "день",
    "theDay_other": "дни",
    "theHour_few": "час",
    "theHour_many": "час",
    "theHour_one": "час",
    "theHour_other": "часы",
    "theMinute_few": "минута",
    "theMinute_many": "минута",
    "theMinute_one": "минута",
    "theMinute_other": "минуты"
};
